export const ROOT = "/admin/warranty";
export const WARRANTEE_LIST = `${ROOT}/view/:warrantyId/`;
